"use client";
import React, { useState, useEffect, useRef } from "react";
import Modal from "@/components/industry-co-led/bachelor-hospitality/Modal";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css/pagination";

const studentTestimonialsData = [
    {
        image:
            "https://cdn.msu.edu.in/msu-lP/Student+Testimonials/zonunmawii.webp",
        video: "https://www.youtube.com/embed/Gun-BPJfpKQ?si=s4lFCu9SX3mZ5T2Z",
        name: "R Zonunmawii",
    },
    {
        image:
            "https://cdn.msu.edu.in/msu-lP/Student+Testimonials/khushi-sarwaiya.webp",
        video:
            "https://www.youtube.com/embed/ouueHyHPoao?si=L8OLm2VLce3KBx8U",
        name: "Khushi Sarwaiya",
    },
    {
        image:
            "https://cdn.msu.edu.in/msu-lP/Student+Testimonials/abhiskek.jpg",
        video: "https://www.youtube.com/embed/Ah4q4-2xIZg?si=kLGCZsAiu4gaidNk",
        name: "Abhishek Kumar",
    },
    {
        image:
            "https://cdn.msu.edu.in/msu-lP/Student+Testimonials/chirag-raj.webp",
        video: "https://www.youtube.com/embed/T9CNx9h5Pxg?si=axnl4_ggxxJewX79",
        name: "Chirag Raj",
    },
    {
        image:
            "https://cdn.msu.edu.in/msu-lP/Student+Testimonials/anubhav.jpg",
        video:
            "https://www.youtube.com/embed/06JEEzi247k?si=IVuWieLKekw-vjZ1",
        name: "Anubhav",
    },
];

const StudentTestimonials = () => {
    const swiperRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({
        src: "",
        type: "image",
    });

    const handleModalOpen = (src, type) => {
        setModalContent({ src, type });
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    useEffect(() => {
        if (showModal) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }

        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [showModal]);

    return (
        <>
            <section className="max-w-(--max-page-width) mx-auto px-(--container-padding) w-full py-16 md:py-24 overflow-hidden">
                <div className="w-full flex flex-col items-center justify-center overflow-hidden">

                    {/* Heading */}
                    <div
                        className="container mx-auto text-center mb-2 px-4"
                       
                    >
                        <p className="text-[#F5A400] uppercase tracking-[4px] text-xs font-semibold mb-4">
                            Testimonials
                        </p>


                        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight w-full max-w-2xl mx-auto text-center">
                            Hear From our Students
                        </h2>

                        <p className="text-black/80 max-w-2xl mx-auto mt-4">
                            Real stories, real journeys—discover how MSU’s hospitality
                            programmes are transforming careers and building confidence
                        </p>
                    </div>

                    {/* Slider */}
                    <div
                        className="relative w-full max-w-7xl mx-auto pb-10 pt-4 px-4"
                       
                    >
                        <Swiper
                            modules={[Pagination, Autoplay]}
                            spaceBetween={30}
                            slidesPerView={1}
                            loop={true}
                            pagination={{ clickable: true }}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            breakpoints={{
                                640: { slidesPerView: 2 },
                                768: { slidesPerView: 3 },
                            }}
                            className="w-full"
                            style={{ paddingBottom: "3rem" }}
                        >
                            {studentTestimonialsData.map((testimonial, index) => (
                                <SwiperSlide key={index}>
                                    <div className="student-card w-full">

                                        <div className="relative w-full rounded-[5px] overflow-hidden">
                                            <img
                                                src={testimonial.image}
                                                alt={testimonial.name}
                                                className="w-full h-auto object-cover"
                                            />

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    handleModalOpen(testimonial.video, "video")
                                                }
                                                className="absolute inset-0 flex items-center justify-center play-button transition"
                                            >
                                                <img
                                                    src="https://cdn.msu.edu.in/landing-page-images/play-button.svg"
                                                    alt="Play Button"
                                                    className="w-12 h-12"
                                                />
                                            </button>

                                        </div>

                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        <button
                            type="button"
                            aria-label="Show previous student testimonial"
                            onClick={() => swiperRef.current?.slidePrev()}
                            className="absolute left-5 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-black shadow-lg transition hover:bg-[#F5A400] md:left-0"
                        >
                            <ChevronLeft className="h-5 w-5" />
                        </button>
                        <button
                            type="button"
                            aria-label="Show next student testimonial"
                            onClick={() => swiperRef.current?.slideNext()}
                            className="absolute right-5 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-black shadow-lg transition hover:bg-[#F5A400] md:right-0"
                        >
                            <ChevronRight className="h-5 w-5" />
                        </button>
                    </div>

                </div>
            </section>

            {/* Modal */}
            {showModal && (
                <Modal
                    mediaSrc={modalContent.src}
                    mediaType={modalContent.type}
                    onClose={handleModalClose}
                />
            )}
        </>
    );
};

export default StudentTestimonials;
